export default "__VITE_ASSET__DrnaQbUF__"